import {Button, Grid, Typography} from "@mui/material"
import {Box} from "@mui/system"
import {FC, useState} from "react"
import {ModalComponent} from "../../../components/Modal/ModalComponent"
import {useAuth} from "../../../firebase/firebaseAuth"
import {AgeGroup, ClimbingEvent, ClimbingEventGroup} from "../../../models/ClimbingEvent"
import {DifficultyCategory, DifficultyCategoryLabel, UserClimbingEvent} from "../../../models/UserClimbingEvent"
import {getSexAsLetter} from "../../../models/UserData"
import {rangeToString, toDate} from "../../../services/time/TimeService"
import {UserDetailsPage} from "../../user/UserDetailsPage"
import {EditUserEventDetailsComponent} from "./components/EditUserEventDetailsComponent"
import {useTranslation} from "react-i18next";

type Props = {
    userEvent: UserClimbingEvent
    handleUpdate: (userEvent: UserClimbingEvent) => void
    event: ClimbingEvent
}

export const UserEventDetailsComponent: FC<Props> = ({userEvent, handleUpdate, event}) => {
  const {t} = useTranslation()
  const {userData} = useAuth()
  const [editingMode, setEditingMode] = useState(!userEvent.category )
  if (!userData) {
    return <></>
  }
  if (userData && (!userData.name || !userData.sex)) {
    return (
      <ModalComponent
        open={true}
        onClose={() => setEditingMode(true)}
        childComp={(
          <>
            <Typography align="center" mb={1} fontWeight={800}>{t('event.user.fillYourData')} </Typography>
            <UserDetailsPage onUpdate={() => setEditingMode(!userEvent.category)}/>
          </>
        )}/>
    )
  }
  return (
    <>
      <Grid container justifyContent="center" alignItems="flex-start">
        <Grid item xs={12} display="flex" gap="5px" justifyContent="center"
              flexDirection={"row"}>
          <Typography align="center" mb={1} fontWeight={800}>{t('event.user.yourData')} </Typography>
          <Typography align="center">{userData.name} </Typography>
          <Typography
            align="center">{userData.birthYear > 0 ? userData.birthYear : t('event.user.fillYourDate')} {t(`user.gender.${getSexAsLetter(userData.sex)}`)}</Typography>

                </Grid>
                <Grid item xs={12} display="flex" flexDirection="column">
                    {((event.allowSection && userEvent.isSection) || Object.keys(DifficultyCategory).length > 1) &&
                        <Box display="flex" gap="5px" justifyContent="center" flexDirection={"row"}>
                            <Typography align="center" mb={1} fontWeight={800}>{t('event.user.category')} </Typography>
                            <Typography
                                align="center">{userEvent.category && Object.keys(DifficultyCategory).length > 1 ? DifficultyCategoryLabel[userEvent.category] : " "}
                                {event.allowSection && `${t('event.section')}: ${userEvent.isSection ? userEvent.section : t('no')}`}</Typography>
                        </Box>
                    }
                    {event.groups && event.groups.length > 0 &&
                        <>
                            <Box display="flex" gap="5px" justifyContent="center">
                                <Typography align="center" mb={1} fontWeight={800}>{t('event.group')}: </Typography>
                                <Typography
                                    align="center">{userEvent.competitionUserData?.group ? groupToString(userEvent.competitionUserData.group) : ""}
                                </Typography>
                            </Box>
                            {event.ageGroups && event.ageGroups.length > 0 && (
                                <Box display="flex" gap="5px" justifyContent="center">
                                    <Typography align="center" mb={1}
                                                fontWeight={800}>{t('event.ageGroup.label')}: </Typography>
                                    <Typography
                                        align="center">{ageGroupForUser(event.ageGroups, userEvent)?.name || t('event.ageGroup.outside')}</Typography>
                                </Box>

                            )}
                            {event.collectCompetitionData && (<>
                                <Box display="flex" gap="5px" justifyContent="center">
                                    <Typography align="center" mb={1} fontWeight={800}>{t('event.city')}: </Typography>
                                    <Typography align="center">{userEvent.competitionUserData?.city || ""} </Typography>
                                </Box>
                                {userEvent.competitionUserData?.sponsorName &&
                                    <Box display="flex" gap="5px" justifyContent="center">
                                        <Typography align="center" mb={1}
                                                    fontWeight={800}>{t('event.club')}: </Typography>
                                        <Typography
                                            align="center">{userEvent.competitionUserData?.sponsorName} </Typography>
                                    </Box>
                                }
                            </>)}
                        </>
                    }
                    {event.collectUserId && (
                        <Box display="flex" gap="5px" justifyContent="center">
                            <Typography align="center" mb={1} fontWeight={800}>{t('user.climbingId')} </Typography>
                            <Typography align="center">{userEvent.startNumber || ""} </Typography>
                        </Box>)}

                    <Box display="flex" justifyContent="center">
                        <Button variant="outlined" onClick={() => setEditingMode(true)}>{t('edit')}</Button>
                    </Box>

                </Grid>
            </Grid>
            <ModalComponent
                open={editingMode}
                onClose={() => setEditingMode(true)}
                childComp={(
                    <Box mx={2}>
                        <Typography align="center" mb={1} fontWeight={800}>{t('event.user.category')} </Typography>
                        <EditUserEventDetailsComponent event={event} userEvent={userEvent} handleUpdate={(ue) => {
                            handleUpdate(ue)
                            setEditingMode(false)
                        }}/>
                    </Box>
                )}/>
        </>)
}
const groupToString = (group: ClimbingEventGroup) => group.name + " " + rangeToString(toDate(group.startDate), toDate(group.endDate))
const ageGroupForUser = (groups: AgeGroup[], user: UserClimbingEvent) => groups.find(g => {
    if (g.endYear) {
        return user.birthYear <= g.endYear && (!g.startYear || user.birthYear >= g.startYear)
    } else {
        return !!g.startYear && user.birthYear >= g.startYear
    }
})
